import { Component, OnInit } from '@angular/core';
import { SeoService } from './../../services/seo.service'


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private seoService:SeoService) {

    this.seoService.setTagsPage({
      title:'Cptur | Inicio',
      type:'website',
      description:'lorem impsup',
      image:'/assets/images/logo.png'
    });

  }

  ngOnInit() {



  }

}
